import { SiteRoute } from '@journeyapps/package-types';
import * as React from 'react';
import { Link, useSearchParams } from 'react-router';
import { PageWidget } from '../../../widgets/layout/PageWidget';
import { S } from './FeatureExplorerStyles';
import { readFeatureSelection, featureSelectionParams } from './featureSelection';
import { PlatformFeaturesWidget } from './PlatformFeaturesWidget';

export const FeaturesPage: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const selection = {
    ...readFeatureSelection(params),
    goals: [],
    traits: [],
    methods: [],
    language: undefined,
    team: undefined,
    governance: []
  };
  return (
    <PageWidget width={1200} title="Platform features">
      <S.Intro>
        <h1>Platform features</h1>
        <p>
          Discover the technologies and features that work together to build applications, automate processes, and
          connect systems.
        </p>
        <Link to={SiteRoute.FEATURE_FINDER}>Help me work out what I need →</Link>
      </S.Intro>
      <PlatformFeaturesWidget
        selection={selection}
        onSelectionChange={(next) => setParams(featureSelectionParams(next), { replace: true })}
      />
    </PageWidget>
  );
};
